import { render } from "./CreateWarehouseModal.vue?vue&type=template&id=d5ca310c"
import script from "./CreateWarehouseModal.vue?vue&type=script&lang=js"
export * from "./CreateWarehouseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__